import { useState, useEffect } from 'react';

/**
 * READ THIS! IF YOU ARE A REACT DEVELOPER YOU SHOULD
 *  https://joshwcomeau.com/react/the-perils-of-rehydration
 */

function useHasMounted() {
  var _useState = useState(false),
      hasMounted = _useState[0],
      setHasMounted = _useState[1];

  useEffect(function () {
    setHasMounted(true);
  }, []);
  return hasMounted;
}

export { useHasMounted };
